"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonContainer = exports.StyledHeading3 = exports.StyledPText = exports.MessageContainer = exports.HeadingContainer = exports.Overlay = exports.Container = exports.StyledModalHeaderIcon = void 0;
const react_native_1 = require("react-native");
const native_1 = __importStar(require("styled-components/native"));
const atoms_1 = require("../../atoms");
const deviceWidth = react_native_1.Dimensions.get('window').width;
exports.StyledModalHeaderIcon = native_1.default.View `
  background: ${({ theme }) => theme.bpCore.colors.white};
  border-radius: 35.5px;
  width: 71px;
  height: 71px;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: -35.5px;
  left: ${deviceWidth / 2 - 35.5}px;
`;
const bottomStyle = native_1.css `
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;
const centerStyle = native_1.css `
  border-radius: 20px;
`;
exports.Container = native_1.default.View `
  flex: 1;
  padding: 32px 24px;
  align-items: center;
  position: absolute;
  background: ${({ theme }) => theme.bpCore.colors.white};
  width: 100%;
  ${({ modalPosition }) => modalPosition === 'bottom' ? bottomStyle : centerStyle}
`;
exports.Overlay = native_1.default.View `
  flex: 1;
  background-color: ${({ theme }) => theme.bpCore.colors.dark[50]};
  justify-content: ${({ modalPosition }) => modalPosition === 'bottom' ? 'flex-end' : 'center'};
`;
exports.HeadingContainer = native_1.default.View `
  margin-top: 32px;
`;
exports.MessageContainer = native_1.default.View `
  margin-top: 16px;
  margin-bottom: 32px;
`;
exports.StyledPText = native_1.default(atoms_1.PText) `
  color: ${({ theme }) => theme.bpCore.colors.dark[500]};
  text-align: center;
`;
exports.StyledHeading3 = native_1.default(atoms_1.Heading3) `
  text-align: center;
`;
exports.ButtonContainer = native_1.default.View `
  width: 100%;
`;
